import { cityAirportData } from "src/interfaces";
import { fetch } from "./http";
import { getUniqueListBy } from "src/helpers";

const controller: string = "v1/reference-data/";

export const fetchAirportsCities = async (keyword = "", token: string) => {
  try {
    const response = await fetch.GetSearch(
      controller +
        `locations?subType=AIRPORT,CITY&keyword=${keyword}&page%5Blimit%5D=10&page%5Boffset%5D=0&sort=analytics.travelers.score&view=FULL`,
      token
    );

    if (response.status === 200) {
      const responseData: any = await response.json();

      if (!responseData?.data || !Array.isArray(responseData.data)) {
        throw new Error("Invalid data format from API");
      }

      const rawData = responseData.data;

      console.log("Raw API response data:", rawData);

      // Store raw data for debugging and persistence
      localStorage.setItem(
        "rawAirportCityData",
        JSON.stringify(responseData.data)
      );
      console.log("Raw API response data stored in localStorage");

      let list: cityAirportData[] = getUniqueListBy(rawData, "iataCode");
      const finalResponse = { ...responseData, data: list };

      console.log(finalResponse, "Final deduplicated response");

      return finalResponse;
    } else if (response.status === 201) {
      const data = await response.json();
      throw new Error(data);
    } else if (response.status !== 429 && response.status !== 401) {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error("fetchAirportsCities error:", error);
    throw error;
  }
};

export const fetchAirportCityDetail = async (code: string, token: string) => {
  try {
    const response = await fetch.GetSearch(
      controller + `locations/${code}`,
      token
    );
    if (response.status === 200) {
      const data = await response.json();
      return data;
    }
  } catch (error) {}
};

// import { cityAirportData } from "src/interfaces";
// import { fetch } from "./http";
// import { getUniqueListBy } from "src/helpers";

// const controller: string = "v1/reference-data/";

// // fetchAirportsCities.ts

// export const fetchAirportsCities = async (keyword = "", token: string) => {
//   try {
//     console.log("fetchAirportsCities called with keyword:", keyword);

//     const url =
//       controller +
//       `locations?subType=AIRPORT,CITY&keyword=${keyword}&page%5Blimit%5D=10&page%5Boffset%5D=0&sort=analytics.travelers.score&view=FULL`;

//     console.log("Request URL:", url);

//     const response = await fetch.GetSearch(url, token);
//     console.log("API response status:", response?.status);

//     if (response.status === 200) {
//       const responseData: any = await response.json();
//       console.log("Raw response data:", responseData);

//       // ✅ Extract only non-null address fields
//       let addressList = responseData?.data
//         ?.map((item: any) => item?.address)
//         ?.filter(Boolean); // Remove null/undefined

//       console.log("Extracted address list:", addressList);

//       // ✅ Filter for only Canadian addresses
//       addressList = addressList.filter(
//         (item) => item.countryName?.toUpperCase() === "CANADA"
//       );

//       console.log("Filtered Canadian addresses:", addressList);

//       // ✅ Remove duplicates (by cityCode + countryCode)
//       addressList = Array.from(
//         new Map(
//           addressList.map((item) => [
//             `${item.cityCode}-${item.countryCode}`,
//             item,
//           ])
//         ).values()
//       );

//       console.log("Deduplicated Canadian addresses:", addressList);

//       // ✅ Save to localStorage
//       const localStorageKey = `airportCityAddresses_${keyword.toUpperCase()}`;
//       localStorage.setItem(localStorageKey, JSON.stringify(addressList));
//       console.log(`Saved to localStorage key: ${localStorageKey}`);

//       return responseData; // Or return addressList if needed
//     } else if (response.status === 201) {
//       const data = await response.json();
//       console.warn("201 status received. Data:", data);
//       throw new Error(data);
//     } else if (response?.status !== 429 && response?.status !== 401) {
//       console.error("Unhandled error status received:", response?.status);
//       throw new Error("Something went wrong");
//     }
//   } catch (error) {
//     console.error("fetchAirportsCities error:", error);
//     throw error;
//   }
// };

// export const fetchAirportCityDetail = async (code: string, token: string) => {
//   try {
//     const response = await fetch.GetSearch(
//       controller + `locations/${code}`,
//       token
//     );
//     if (response.status === 200) {
//       const data = await response.json();
//       return data;
//     }
//   } catch (error) {}
// };
